"use client";
import { ChooseArtOrderModal } from "../ChooseArtOrderModal";
import { useState } from "react";
import BrushIcon from "@/assets/icons/brush.svg";
import useOrdersForOpenToWorkArtist from "../hooks/useOrdersForOpenToWorkArtist";
import { ChooseArtOrderSuccessModal } from "../ChooseArtOrderSuccessModal";
import { Button } from "@/app/(components)/Basic/Button";

export interface Props {
  userDisplayName: string;
  artistId: string;
}

const HireArtistButton = ({ artistId }: Props) => {
  const [isChooseArtOrderModalVisible, setIsChooseArtOrderModalVisible] =
    useState<boolean>(false);
  const [
    isChooseArtOrderSuccessModalVisible,
    setIsChooseArtOrderSuccessModalVisible,
  ] = useState<boolean>(false);

  const { artOrders } = useOrdersForOpenToWorkArtist(artistId);

  const onSuccessfulInvite = () => {
    setIsChooseArtOrderModalVisible(false);
    setIsChooseArtOrderSuccessModalVisible(true);
  };
  return (
    <>
      {!!artOrders?.length && (
        <>
          <Button
            startIcon={<BrushIcon className="w-6 h-6" />}
            onClick={() =>
              setIsChooseArtOrderModalVisible(!isChooseArtOrderModalVisible)
            }
          >
            Hire <span className="hidden sm:inline">&nbsp;an artist</span>
          </Button>
          <ChooseArtOrderModal
            artistId={artistId}
            artOrders={artOrders}
            isOpen={isChooseArtOrderModalVisible}
            onClose={() => setIsChooseArtOrderModalVisible(false)}
            onSuccess={onSuccessfulInvite}
          />
        </>
      )}

      <ChooseArtOrderSuccessModal
        isVisible={isChooseArtOrderSuccessModalVisible}
        onClose={() => setIsChooseArtOrderSuccessModalVisible(false)}
      />
    </>
  );
};

export default HireArtistButton;
